// src/components/NavBar.tsx
import PillNav from "./PillNav";
import logo from "../logo.svg";

const NavBar: React.FC = () => {
    return (
        <nav className="w-full flex justify-center sticky top-0 z-50">
            <PillNav
                logo={logo}
                logoAlt="Company Logo"
                items={[
                    { label: "Home", href: "#car" },
                    { label: "History", href: "#history" },
                    { label: "Team", href: "#the-team" },
                    { label: "Partners", href: "#partners" },
                ]}
                activeHref="/"
                className="custom-nav"
                ease="power2.easeOut"
                baseColor="#701f844d"
                pillColor="#ffffffff"
                hoveredPillTextColor="#ffffff"
                pillTextColor="#000000"
            />
        </nav>
    );
};

export default NavBar;
